
import AreaManagerForm from '@/components/Settings/AreaManager/Form';

export default {
  components: {
    AreaManagerForm
  }
};
